import Accordion from '../util/accordion';

class FAQAccordion {
  constructor(el) {
    this.el = el;
    this.accordionEl = this.el.querySelector('[data-accordion]');
    this.init();
  }

  init() {
    // TODO fix icon and line anim
    new Accordion(this.accordionEl);
  }
}

export default FAQAccordion;
